// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-18dee4bc] .ck-editor__editable_inline{min-height:500px!important;max-height:800px!important;overflow-y:auto}.currency-input[data-v-18dee4bc]{width:200px;padding:5px;font-size:16px}.swal2-icon[data-v-18dee4bc]{display:flex!important;justify-content:center;align-items:center;width:5em!important;height:5em!important;font-size:3em!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
